import { Link, useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { ShieldCheck, List, X, SignOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/cra-readiness", label: "CRA Readiness" },
  { to: "/iec-62443", label: "IEC 62443" },
  { to: "/machinery-ukca", label: "EU MR, UKCA & PSTI" },
];

export const SiteHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200/70 glass">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-logo">
          <ShieldCheck size={26} weight="duotone" className="text-navy-800" />
          <span className="font-display text-[17px] font-extrabold text-navy-900">
            ProductSecurity<span className="text-navy-800">Ready</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.slice(1)}`}
              className={`text-sm transition-colors hover:text-navy-800 ${
                pathname === n.to ? "text-navy-800 font-medium" : "text-slate-600"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          {user ? (
            <>
              {user.role === "admin" && (
                <Button variant="ghost" size="sm" onClick={() => navigate("/admin")} data-testid="header-admin-link">
                  Admin
                </Button>
              )}
              <Button variant="outline" size="sm" onClick={() => navigate("/dashboard")} data-testid="header-dashboard-link">
                Dashboard
              </Button>
              <Button
                size="sm"
                variant="ghost"
                onClick={async () => {
                  await logout();
                  navigate("/");
                }}
                data-testid="header-logout-button"
              >
                <SignOut size={16} className="mr-1.5" /> Log out
              </Button>
            </>
          ) : (
            <>
              <Button variant="ghost" size="sm" onClick={() => navigate("/login")} data-testid="header-login-button">
                Log in
              </Button>
              <Button
                size="sm"
                className="bg-navy-800 hover:bg-navy-700 text-white"
                onClick={() => navigate("/register")}
                data-testid="header-check-product-button"
              >
                Check my product
              </Button>
            </>
          )}
        </div>

        <button
          className="md:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <List size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-slate-200 bg-white px-5 py-4 md:hidden" data-testid="mobile-menu">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              onClick={() => setOpen(false)}
              className="block py-2 text-sm text-slate-700"
            >
              {n.label}
            </Link>
          ))}
          <div className="mt-3 flex gap-2">
            {user ? (
              <Button size="sm" className="w-full bg-navy-800 text-white" onClick={() => navigate("/dashboard")}>
                Dashboard
              </Button>
            ) : (
              <>
                <Button size="sm" variant="outline" className="w-full" onClick={() => navigate("/login")}>
                  Log in
                </Button>
                <Button size="sm" className="w-full bg-navy-800 text-white" onClick={() => navigate("/register")}>
                  Get started
                </Button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};
